module.exports = __webpack_public_path__ + "static/img/illustrator_128.c300a3bc.png";